import { render, staticRenderFns } from "./RegistrationMessage.vue?vue&type=template&id=405e3ade&scoped=true&"
import script from "./RegistrationMessage.vue?vue&type=script&lang=js&"
export * from "./RegistrationMessage.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationMessage.vue?vue&type=style&index=0&id=405e3ade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405e3ade",
  null
  
)

export default component.exports